import { useCallback } from 'react';
import { useHttpFetchApi } from '../http/useHttpFetch';
import { StudyParticipant } from '../../models/StudyParticipant';

export function useJoinPublicStudy() {
  const { loading, error, postJson } = useHttpFetchApi();
  const joinPublicStudy = useCallback(
    (studyId: number) => {
      return postJson<StudyParticipant>(`studies/${studyId}/join`);
    },
    [postJson]
  );

  return { loading, error, joinPublicStudy };
}
